import React from "react";
import Select from "react-select";
import { sweetalert } from "../../App";
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";
import { buildRow, getBoolSelectOptions, getBoolSelectVal, trimStringFields } from "../../util/FormatUtil";
import { isEmptyObject } from "jquery";
import GetField from "../../customfields/GetField";
import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder";
import { SpecimenSource } from "../../types/SpecimenSource";
import { getFieldReadOnly, FieldPermissions } from "../../util/RolePermissions";

interface SpecimenSourceManagementState {
  selectedSpecimenSource: SpecimenSource
  customFieldData?
}
interface SpecimenSourceManagementProps {
  selectedSpecimenSource:SpecimenSource
  onSubmit?
  pageCustomQuestions?
  userRoles?
  fieldPermissions?: FieldPermissions
}
export class SpecimenSourceManagementModal extends React.Component<SpecimenSourceManagementProps, SpecimenSourceManagementState> {
  public static ID = "specimensource";
  constructor(props) {
    super(props);
    this.state = {
      selectedSpecimenSource: {
        ID: null,
        Name: "",
        Description: null,
        StarlimsName: "",
        IsEnabled: null,
        LOINCCode: "",
        LOINCDescription: "",
        CustomFieldData: null,
        CreatedDate: null,
        CreatedBy: "",
        UpdatedDate: null,
        UpdatedBy: "" 
      } as SpecimenSource
    } as SpecimenSourceManagementState
  }

  componentWillReceiveProps(nextProps: Readonly<SpecimenSourceManagementProps>, nextContext: any) {
    // console.log('SpecimenSourceMgmt modal nextProps', nextProps)
    if (!isEmptyObject(nextProps.selectedSpecimenSource)) {
      let specimenSource = nextProps.selectedSpecimenSource;
      this.setState({
        selectedSpecimenSource: {
          ID: specimenSource.ID ? specimenSource.ID : null,
          Name: specimenSource.Name ? specimenSource.Name : "",
          Description: specimenSource.Description ? specimenSource.Description : "",
          StarlimsName: specimenSource.StarlimsName ? specimenSource.StarlimsName : "",
          IsEnabled: specimenSource.IsEnabled ? specimenSource.IsEnabled : null,
          LOINCCode: specimenSource.LOINCCode ? specimenSource.LOINCCode : "",
          LOINCDescription: specimenSource.LOINCDescription ? specimenSource.LOINCDescription : "",  
          CustomFieldData: specimenSource.CustomFieldData && JSON.stringify(specimenSource.CustomFieldData) !== '{}' ? JSON.parse(specimenSource.CustomFieldData) : null,
          CreatedDate: specimenSource.CreatedDate ? specimenSource.CreatedDate : new Date()
        } as SpecimenSource
      });
    }
  }

  render() {
    // console.log('SpecimenSourceMgmt modal state', this.state)
    return (
      <div className="modal fade form_modal" id={SpecimenSourceManagementModal.ID} tabIndex={-1} role="dialog"
        aria-labelledby="specimen_Source_modal_label"
        aria-hidden="true">
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="specimen_Source_modal_label">Specimen Source Management</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {buildRow("Specimen Source",
                  <input className={"form-control"}
                    maxLength={50}
                    readOnly={this.state.selectedSpecimenSource.ID != null}
                    autoComplete={"off"}
                    type={"search"}
                    name={"SpecimenSource"}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedSpecimenSource: {
                          ...prevState.selectedSpecimenSource,
                          Name: e.target.value
                        }
                      }))
                    }}
                    value={this.state.selectedSpecimenSource.Name}
                  />,
                  'Name of Specimen Source',
                  true
                )}
                {buildRow("Description",
                  <input
                    className={"form-control"}
                    maxLength={50}
                    autoComplete={"off"}
                    type={"search"}
                    name={"Description"}
                    onChange={(e) => this.setState((prevState) => ({
                      selectedSpecimenSource: {
                        ...prevState.selectedSpecimenSource,
                        Description: e.target.value
                      }
                    }))}
                    value={this.state.selectedSpecimenSource.Description}
                  />,
                  "Short Description of Specimen Source",
                  true
                )}

                {buildRow("Starlims Name",
                  <input
                    className={"form-control"}
                    maxLength={50}
                    autoComplete={"off"}
                    type={"search"}
                    name={"StarlimsName"}
                    onChange={(e) => this.setState((prevState) => ({
                      selectedSpecimenSource: {
                        ...prevState.selectedSpecimenSource,
                        StarlimsName: e.target.value
                      }
                    }))}
                    value={this.state.selectedSpecimenSource.StarlimsName}
                  />,
                  'Mapping for Starlims POST'
                )}

                {buildRow("LOINC Code",
                  <input className={"form-control"}
                    maxLength={50}
                    // readOnly={this.state.selectedSpecimenSource.ID != null}
                    autoComplete={"off"}
                    type={"search"}
                    name={"LOINCCode"}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedSpecimenSource: {
                          ...prevState.selectedSpecimenSource,
                          LOINCCode: e.target.value
                        }
                      }))
                    }}
                    value={this.state.selectedSpecimenSource.LOINCCode || ""}
                  />,
                  'LOINC Code for Specimen Source',
                  false 
                )}
                {buildRow("LOINC Description",
                  <input className={"form-control"}
                    maxLength={50}
                    // readOnly={this.state.selectedSpecimenSource.ID != null}
                    autoComplete={"off"}
                    type={"search"}
                    name={"LOINCDescription"}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedSpecimenSource: {
                          ...prevState.selectedSpecimenSource,
                          LOINCDescription: e.target.value
                        }
                      }))
                    }}
                    value={this.state.selectedSpecimenSource.LOINCDescription || ""}
                  />,
                  'LOINC Description for Specimen Source',
                 false 
                )}
                {buildRow("Is Enabled?",
                  <Select
                    isSearchable={true}
                    placeholder={"Please Select..."}
                    noOptionsMessage={() => "No option"}
                    value={this.state.selectedSpecimenSource.ID ? getBoolSelectVal(this.state.selectedSpecimenSource.IsEnabled) :
                      this.state.selectedSpecimenSource.IsEnabled === 1 || this.state.selectedSpecimenSource.IsEnabled === 0 ? getBoolSelectVal(this.state.selectedSpecimenSource.IsEnabled) :
                        null}
                    onChange={(e) => this.setState((prevState) => ({
                      selectedSpecimenSource: {
                        ...prevState.selectedSpecimenSource,
                        IsEnabled: e.value ? 1 : 0
                      }
                    }))}
                    className={"state_select"}
                    options={getBoolSelectOptions()}
                  />,
                  'Enabled Specimen Sources can be assigned to Tests',
                  true
                )                }
                {/*Custom Field Data*/}

                {
                  (this.props.pageCustomQuestions)
                    ?
                    <div className="row">
                      {this.props.pageCustomQuestions.map((val, index) => {
                        if (val.Options.isActive) {
                          return (
                            <div className="col-12">
                              <div className="form-group row">
                                <GetField
                                  val={val}
                                  isRequired={val.Options.isRequired}
                                  readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)}
                                  selectedItem={this.state.selectedSpecimenSource ? this.state.selectedSpecimenSource : null}
                                  handleChange={(e) => {
                                    this.setState({ selectedSpecimenSource: e })
                                  }}
                                />
                              </div>
                            </div>
                          )
                        }
                        else {
                          return <></>
                        }
                      })}
                    </div>
                    :
                    <div className="invisible"></div>
                }


              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={() => {
                  if (isBlank(this.state.selectedSpecimenSource.Name) ||
                    isOnlyWhitespace(this.state.selectedSpecimenSource.Name)
                  ) {
                    return sweetalert.fire("Attention", "Specimen Source Name cannot be empty.", "error")
                  }
                  if (isBlank(this.state.selectedSpecimenSource.Description) || isOnlyWhitespace(this.state.selectedSpecimenSource.Description)) {
                    return sweetalert.fire("Attention", "Specimen Source Description cannot be empty", "error")
                  }
                  if (this.state.selectedSpecimenSource.IsEnabled === null && this.state.selectedSpecimenSource.ID === null) {
                    return sweetalert.fire("Attention", "Please select a value for Is Enabled", "error")
                  }
                  let invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedSpecimenSource.CustomFieldData, this.props.pageCustomQuestions, this.state.selectedSpecimenSource)

                  if (invalid) {
                    return;
                  }


                  this.props.onSubmit(trimStringFields({...this.state.selectedSpecimenSource}, ["Name", "Description", "StarlimsName", "LOINCCode", "LOINCDescription"]));
                }}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}